import Vue from 'vue'
import Router from 'vue-router'
import routes from './routesCopy'
import Waiting from '@/components/waiting'

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return VueRouterPush.call(this, location).catch(err => err)
}

const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  return VueRouterReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  routes,
  scrollBehavior: () => ({ y: 0 })
})

const whitelist = ['login']

// router.beforeEach((to, from, next) => {
//   Waiting.show()
//   if (whitelist.indexOf(to.name) === -1 && !localStorage.getItem('token')) {
//     Waiting.hidden()
//     console.log('走');
    
//     next('/login')
//   } else {
//     setTimeout(() => {
//       next()
//     }, 10)
//   }
// })

router.afterEach(to => {
  Waiting.hidden()
  document.title = to.meta.title
})

export default router

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = new Router({
    routes,
    scrollBehavior: () => ({ y: 0 })
  })
  // reset router
  router.matcher = newRouter.matcher
}
